export default "__VITE_ASSET__3b03da70__"